module.exports = "<div class=\"dashboard\">\n  <h2 translate>code.welcome</h2>\n</div>\n";